import React, { useState, useEffect } from "react";
import "./news.css";

const InfiniteScrollAnimation = () => {
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/landing`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0 && data[0].news) {
          setNewsItems(data[0].news);
        }
      })
      .catch(err => console.error("Error fetching news data", err));
  }, []);

  const displayNews = newsItems.length > 0 ? newsItems : [
    "Admission open for Session 2025-26",
    "Playgroup to 8th standard"
  ];

  return (
    <div className="scroll-container">
      <div className="content">
        <div className="item">
          <ul>
            {displayNews.map((news, idx) => (
              <li key={idx}>{news}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InfiniteScrollAnimation;
